function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { settingsActions } from '../../reducers/settings.reducer';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import MetaDataRouteDetails from './meta-data/MetaDataRouteDetails.react';
import SelectApplication from '../common/form/select/SelectApplication.react';
import Label from '../common/form/Label.react';
var MetaData = function MetaData(_ref) {
  var metaData = _ref.metaData,
    getMetaDataAction = _ref.getMetaDataAction;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedApp = _useState2[0],
    setSelectedApp = _useState2[1];
  useEffect(function () {
    getMetaDataAction();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Meta Data"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Select Application"
  }), /*#__PURE__*/React.createElement(SelectApplication, {
    value: selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.sValue,
    onChange: function onChange(option) {
      return setSelectedApp(option);
    }
  }))), selectedApp && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MetaDataRouteDetails, {
    selectedApp: selectedApp,
    metaData: metaData,
    key: selectedApp.sValue
  })))));
};
var mstp = function mstp(s) {
  return {
    metaData: s.settings.metaData
  };
};
var mdtp = {
  getMetaDataAction: settingsActions.getMetaData
};
export default connect(mstp, mdtp)(MetaData);